type CheckBrowserAllowed = 'chrome' | 'edge' | 'firefox' | 'safari' | 'opera' | 'ie'

const browserSlugs: Record<CheckBrowserAllowed, RegExp> = {
    chrome: /Chrome/,
    edge: /Edg/,
    firefox: /Firefox/,
    safari: /Safari/,
    opera: /Opera|OPR/,
    ie: /MSIE|Trident/,
}

export const checkBrowser = (allowedBrowser: CheckBrowserAllowed[] | undefined) => {
    if (!allowedBrowser) return true

    const { userAgent } = navigator

    const res = allowedBrowser?.reduce<boolean[]>((acc, curr) => {
        const regexp = browserSlugs[curr]

        if (regexp) {
            acc.push(regexp.test(userAgent))
        }

        return acc
    }, [])

    return res.includes(true)
}
